<template>
  <div>
    <v-card class="py-3">
      <v-card-title>
        <span class="title">
          {{ $t('reports.consumption.title') }}
        </span>
      </v-card-title>
      <v-card-subtitle>
        <span class="subheading">
          {{ $t('reports.consumption.description') }}
        </span>
      </v-card-subtitle>
      <v-card-text>
        <span class="body-2">
          {{ $t('reports.consumption.chooseDateRange') }}
        </span>
        <div class="d-flex justify-center">
          <v-date-picker
            v-model="selectedDates"
            ref="picker"
            color="primary"
            range
            :first-day-of-week="1"
            :allowed-dates="allowedDates"
            @input="orderDateRange"
            reactive
            no-title
            :locale="locale">
          </v-date-picker>
        </div>
      </v-card-text>
      <v-card-actions class="d-flex align-center justify-center">
        <v-btn @click="download" color="primary darken-1" :disabled="canDownload">
          {{ loading ? $t('reports.downloading') : $t('reports.download') }}
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-snackbar v-model="snackbar" :color="snackBarColor" :timeout="3000">
      <span class="body-1">
        {{ snackbarText }}
      </span>
    </v-snackbar>
  </div>
</template>

<script>
import getLocale from '@/lang/locale'

export default {
  name: 'Consumption',
  data () {
    return {
      loading: false,
      snackbar: false,
      snackbarText: '',
      snackBarColor: null,
      selectedDates: []
    }
  },
  computed: {
    restaurant () {
      return this.$store.state.currentRestaurant.data
    },
    locale () {
      return getLocale(this.$i18n.locale)
    },
    canDownload () {
      return this.selectedDates.length !== 2 || this.loading
    }
  },
  mounted () {
    const today = new Date()
    this.month = `${today.getFullYear()}-${(today.getMonth() + 1)
      .toString()
      .padStart(2, '0')}`
  },
  methods: {
    allowedDates (val) {
      return this.$moment(val).isSameOrBefore(new Date())
    },
    orderDateRange () {
      this.selectedDates.sort((a, b) => new Date(a) - new Date(b))
    },
    downloadFile (response) {
      const link = document.createElement('a')
      const restaurantName = this.restaurant.name.toLowerCase().replace(' ', '-')
      const fileName = `reporte-${restaurantName}-${this.selectedDates[0]}-${this.selectedDates[1]}.xlsx`
      link.href = 'data:application/octet-stream;base64,' + response
      link.download = fileName
      link.click()
      this.loading = false
    },
    showSnackBar (message, success) {
      this.snackBarColor = success ? 'success darken-1' : 'error darken-1'
      this.snackbarText = message
      this.snackbar = true
    },
    resetCalendar () {
      this.selectedDates = []
    },
    async download () {
      this.loading = true
      try {
        const response = await this.$api.post(`/v1/restaurants/${this.restaurant._id}/reports/consumption`, {
          startDate: this.selectedDates[0],
          endDate: this.selectedDates[1]
        }, { timeout: 10 * 60 * 1000 })
        this.downloadFile(response)
        this.showSnackBar(this.$t('reports.successfulDownload'), true)
      } catch (error) {
        this.showSnackBar(error.message, false)
        this.loading = false
      }
      this.resetCalendar()
    }
  }
}
</script>
